import { Group, Input, Radio, Text, ThemeIcon } from '@mantine/core';
import type { IconAlarm } from '@tabler/icons-react';
import { useTranslation } from 'locales';

type TablerIcon = React.ComponentType<React.ComponentProps<typeof IconAlarm>>;

export type CardOption<TValue extends string> = {
  value: TValue;
  labelKey: string;
  Icon: TablerIcon;
};

type OptionCardGroupProps<TValue extends string> = {
  label: string;
  value: TValue;
  options: CardOption<TValue>[];
  onChange: (value: TValue) => void;
};

export function OptionCardGroup<TValue extends string>({
  label,
  value,
  options,
  onChange,
}: OptionCardGroupProps<TValue>) {
  const { t } = useTranslation();

  return (
    <Input.Wrapper label={label}>
      <Radio.Group value={value} onChange={next => onChange(next as TValue)}>
        <Group grow gap="sm">
          {options.map(({ value: optionValue, labelKey, Icon }) => (
            <Radio.Card key={optionValue} value={optionValue} p="sm" radius="md">
              <Group gap="sm" wrap="nowrap" align="center">
                <Radio.Indicator />
                <ThemeIcon variant="light" size="lg" radius="md">
                  <Icon size={18} />
                </ThemeIcon>
                <Text size="sm">{t(labelKey)}</Text>
              </Group>
            </Radio.Card>
          ))}
        </Group>
      </Radio.Group>
    </Input.Wrapper>
  );
}
